import React, { SVGProps } from 'react'
const SvgBetaPurple = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill="#6724F9" fillRule="evenodd">
      <path d="m8 13-2 5 1 1h10l1-1-2-5z" />
      <path
        fillRule="nonzero"
        d="M15.41 4a.5.5 0 0 1 .089.992l-.09.008h-7a.5.5 0 0 1-.09-.992L8.41 4h7ZM11.41 6a.5.5 0 0 1 .089.992l-.09.008h-2a.5.5 0 0 1-.09-.992L9.41 6h2ZM11.91 8a.5.5 0 0 1 .089.992l-.09.008h-2.5a.5.5 0 0 1-.09-.992L9.41 8h2.5ZM11.41 10a.5.5 0 0 1 .089.992l-.09.008h-2a.5.5 0 0 1-.09-.992L9.41 10h2Z"
      />
      <path
        fillRule="nonzero"
        d="M9.41 4a.5.5 0 0 1 .491.41l.008.09v6a.5.5 0 0 1-.992.09l-.008-.09v-6a.5.5 0 0 1 .5-.5ZM14.41 4a.5.5 0 0 1 .491.41l.008.09v6a.5.5 0 0 1-.992.09l-.008-.09v-6a.5.5 0 0 1 .5-.5ZM15.91 13a.5.5 0 0 1 .089.992l-.09.008h-8a.5.5 0 0 1-.09-.992L7.91 13h8Z"
      />
      <path
        fillRule="nonzero"
        d="M8.962 10.276a.5.5 0 0 1 .927.364l-.033.084-3 6a.5.5 0 0 1-.927-.364l.033-.084 3-6Z"
      />
      <path
        fillRule="nonzero"
        d="m5.962 16.276.894.448c-.789 1.578-.308 2.235 1.84 2.274l.213.002v1c-2.93 0-4.075-1.286-3.032-3.548l.085-.176Z"
      />
      <g fillRule="nonzero">
        <path d="M14.856 10.276a.5.5 0 0 0-.927.364l.033.084 3 6a.5.5 0 0 0 .927-.364l-.033-.084-3-6Z" />
        <path d="m17.856 16.276-.894.448c.803 1.605.443 2.235-1.367 2.274l-.186.002v1c2.625 0 3.568-1.31 2.535-3.54l-.088-.184Z" />
      </g>
      <path
        fillRule="nonzero"
        d="M15.41 19a.5.5 0 0 1 .089.992l-.09.008h-7a.5.5 0 0 1-.09-.992L8.41 19h7Z"
      />
    </g>
  </svg>
)
export default SvgBetaPurple
